import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { PreferenceService } from 'src/app/services/preference.service';
import { LprDataService } from 'src/app/services/lpr-data.service';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { GeofenceDetailService } from 'src/app/services/geofencedetail.service';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { parse } from 'path';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeofenceService } from 'src/app/services/geofence.service';
import { GeofenceZoneService } from 'src/app/services/geofencezone.service';
import { ZoneService } from 'src/app/services/zone.service';
declare const google: any;

@Component({
    selector: 'app-interactive-geofence',
    templateUrl: './interactive-geofence.component.html',
    styleUrls: ['./interactive-geofence.component.scss']
})
export class InteractiveGeofenceComponent implements OnInit {
  deleteResponseCount: number = 0;
  zoneData: any;
  geofenceZoneData: any;
  info: boolean =false;

constructor(
    private activatedRoute: ActivatedRoute,
    public preferenceService: PreferenceService,
    public dialog: MatDialog,
    public userService: UserService,
    public router: Router,
    public toaster: ToastrService,
    public lprdataservice: LprDataService,
    public authenticationService: AuthenticationService,
    public geofenceDetailService: GeofenceDetailService,
    public geofenceService: GeofenceService,
    public geofenceZoneService: GeofenceZoneService,
    public zoneService: ZoneService,){}

    public lat;
    public lng;
    
    public zoneList: any = [];

    public allGeofenceDetailsById;
    public allGeofenceDetails;
    public deleteresponse;

    center: any = {
      lat: 34.063159,
      lng: -84.167151
    };
  
    mapType = "satellite";
    mapZoom= 18;
  
    public drawingManager : any;
  
    public geofenceName: any = '';
    public geofenceId: any = '';

    public orgId: any;
  
    public polyArrayLatLng: any[] = [];
    allGeofenceIds : any;
    allGeofenceNames: any;
  
    public map = null;
  
    public polygon :any;
    public createPolygon = false;
    polygonData:any = {
      "strokeColor" : "#BBBAD2",
      "strokeOpacity" : 0.2,
      "strokeWeight" : 2,
      "fillColor" : "#BBBAD2",
      "fillOpacity" : 0.35,
      "draggable" : false,
      "editable" : true,
      "visible" : true,
      "ZonePaths": []
      }

      previousPolygonData:any = {
        "strokeColor" : "#BBBAD2",
        "strokeOpacity" : 0.2,
        "strokeWeight" : 2,
        "fillColor" : "#BBBAD2",
        "fillOpacity" : 0.35,
        "draggable" : false,
        "editable" : true,
        "visible" : true,
        "ZonePaths": []
        }

  ngOnInit() {
    this.geofenceName = this.activatedRoute.snapshot.queryParamMap.get('geofenceName');
    this.geofenceId = this.activatedRoute.snapshot.queryParamMap.get('geofenceId');
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    this.getAllGeofenceDetialByID(this.geofenceId);
    this.setCurrentPosition();
    this.getAllGeofenceZoneById(this.geofenceId);
    this.getAllZone();

    this.getAllGeofenceDetails();
    this.getAllGeofenceName();
    // this.getAllGeofenceZone();
  }


  getAllGeofenceName(): void {
    this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allGeofenceNames = response.data;
        } else {
          console.log("Geofence API Error!");
        }
      } , error =>{
        console.log(error);
      });
  }

  getAllGeofenceDetails(): void {
    this.geofenceDetailService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {

          this.allGeofenceIds = [...new Set(response.data.map(item => item.geofenceId))];
          var allGeofencesByIds = [];

          for(let i=0; i<this.allGeofenceIds.length; i++){
            var geofence = response.data.filter((geoData)=>{
              return geoData.geofenceId == this.allGeofenceIds[i]
            });

            geofence.sort((a, b) => {
              return a.sequence - b.sequence;
            });
            
            for(let j=0; j<geofence.length; j++){
              geofence[j].lat = parseFloat(geofence[j].lat);
              geofence[j].lng = parseFloat(geofence[j].lng);
            }

            allGeofencesByIds.push(geofence);
          }

          this.allGeofenceDetails = allGeofencesByIds;
        } 
        else {
          console.log("Geofence Detail API Error!");
        }
      });
  }

  getAllGeofenceZone(): void {
    this.geofenceZoneService.getAll()
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.geofenceZoneData = response.data;
      } else {
        console.log("Zone API Error!");
      }
    });
  }

  filterGeofenceName(geoId): void{
    var geoName = this.allGeofenceNames.filter((geoData)=>{
      return geoData.geofenceId == geoId;
    })

    return geoName[0].geofenceName;
  }

  getAllZoneIdsByGeofenceId(geoId):void{
    this.zoneList = [];
    var geoZone = this.geofenceZoneData.filter(x=>x.geofenceId == geoId);

    geoZone.forEach(element =>{
      this.zoneList.push(element.zoneId);
    });
  }


  getZoneNameByZoneId(zoneId){
    let myObj = this.zoneData.filter(x=>x.zoneId == zoneId)[0];

    if(myObj == undefined){
      let myZone = "Zone Deleted!";
      return myZone;
    }
    else{
      let myZone = Object.assign({},myObj);
      return myZone.zoneName;
    }
  }

  getZoneName(zoneId){
    let myObj = this.zoneData.filter(x=>x.zoneId == zoneId)[0];
    // console.log("filter zone",myObj);
    if(myObj == undefined){
      let myZone = "Zone Deleted!";
      return myZone;
    }
    else{
      let myZone = Object.assign({},myObj);
      // console.log(myZone);
      return myZone.zoneName;
    }
  }

  viewInfo(){
    this.info = true;
  }

  closeInfo(){
    this.info = false;
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
        } else {
          console.log("Zone API Error!");
        }
      });
  }
  
  getAllGeofenceZoneById(geofenceId): void {
    this.geofenceZoneService.getAll()
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.zoneList = [];
        this.geofenceZoneData = response.data.filter(x=>x.geofenceId == geofenceId);
        this.geofenceZoneData.forEach(element =>{
          this.zoneList.push(element.zoneId);
        });
      } else {
        console.log("Zone API Error!");
      }
    });
  }

  getAllGeofenceDetialByID(geofenceId: any) {
    this.geofenceDetailService.GeofenceDetailFindByGeofenceId(geofenceId)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allGeofenceDetailsById = response.data;
          let allGeofenceDetails = response.data;
          let ZonePaths: any = []; 
          let lat,lng;
          if(allGeofenceDetails.length > 0){
            setTimeout(()=>{
            document.getElementsByTagName('button')[1].click();
            this.info = true;
            },1000);
            allGeofenceDetails.map(geofenceDetail => {
              ZonePaths.push({lat: Number(geofenceDetail.lat), lng: Number(geofenceDetail.lng)})
              lat = Number(geofenceDetail.lat);
              lng = Number(geofenceDetail.lng);
            })
            this.polygonData.ZonePaths = ZonePaths;
            this.center.lat = lat;
            this.center.lng = lng;
          }
          else{
            this.createPolygon = true;
            if(this.polygonData){
              this.polygonData.ZonePaths = []
            }
            if(this.polygon){
              this.polygon.setMap(null);
            }
            this.initDrawingManager(this.map);
          }
         
        } else {
          this.toaster.error(response.value,"Failed To Load Data!")
        }
      });
  }

  AddGeoFenceDetail(payload: any){
    this.geofenceDetailService.addGeofenceDetail(payload).pipe(first()).subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.saveResponse(response);
      }
    })
  }

  DeleteGeoFenceDetail(payload: any){
    this.geofenceDetailService.deleteGeofenceDetail(payload).pipe(first()).subscribe(response => {
      this.deleteresponse = response;
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.deleteResponse(response);
      }
    })
  }

  deleteResponse(response){
    if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
      this.deleteResponseCount = this.deleteResponseCount + 1;
      if(this.deleteResponseCount == this.allGeofenceDetailsById.length){
        this.deleteResponseCount = 0;
        this.toaster.success("GeoFence Map Deleted Successfully");
        this.ngOnInit();
        this.createPolygon = true;
      }
    }
  }

  saveResponse(response){
    if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
      this.deleteResponseCount = this.deleteResponseCount + 1;
      if(this.deleteResponseCount == this.polyArrayLatLng.length){
        this.deleteResponseCount = 0;
        this.toaster.success("GeoFence Map Added Successfully");
        this.getAllGeofenceDetialByID(this.geofenceId);
        this.createPolygon = false;
      }
    }
  }

  saveGeoFenceDetail(){
    this.polyArrayLatLng.forEach(element => {
      let payload = {
        geofenceId: this.geofenceId,
        lat: element.latitude,
        lng: element.longtitude,
        sequence: element.sequence,
        status:WebConstants.INT_ONE,
        organizationId:this.orgId
      }
      this.AddGeoFenceDetail(payload);
    });
  }

  removeGeoFenceDetail(){
    this.allGeofenceDetailsById.forEach(element => {
      this.DeleteGeoFenceDetail(element.id);
    });    
  }

  onMapReady(map) {
    this.initDrawingManager(map);
  }

  wt(evt) { 
    this.mapType= evt;
  }

  goBack(){
    this.router.navigate([WebConstants.WEB_URL.GEOFENCE]);
  }

  inputChecked(data:any){
    let check = false;
    let checkInput = this.zoneList.includes(data);
    return checkInput;
  }

  onChange(data:string, isChecked: boolean) {
    if (isChecked) {
      this.zoneList.push(data);
    } else {
      this.zoneList.splice(this.zoneList.indexOf(data),1);
    }
  }

  deleteGeofenceZoneByGeofenceId(data): void{
    this.geofenceZoneService.deleteGeofenceZoneByGeofenceId(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        this.saveGeoFenceZone();
      }
    })
  }

  saveGeoFenceZone(){
    this.zoneList.forEach(zoneid => {
      let payload = {
        geofenceId: this.geofenceId,
        zoneId: zoneid,
        organizationId: this.orgId,
        status: 1
      }
      this.addGeofenceZoneData(payload);
    });
  }

  addGeofenceZoneData(data): void{
    this.geofenceZoneService.addGeofenceZone(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        // this.router.navigate([WebConstants.WEB_URL.GEOFENCE], {});
      }
    })
  }

  initDrawingManager(map: any) {
    const input = document.getElementById("pac-input") as HTMLInputElement;
    const searchBox = new google.maps.places.SearchBox(input);

    map.addListener("bounds_changed", () => {
      searchBox.setBounds(map.getBounds());
    });

    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();
  
      if (places.length == 0) {
        return;
      }
  
      let markers = [];
      // Clear out the old markers.
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];
  
      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds();
  
      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          console.log("Returned place contains no geometry");
          return;
        }
  
        const icon = {
          url: place.icon,
          size: new google.maps.Size(0, 0),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };
  
        // Create a marker for each place.
        markers.push(
          new google.maps.Marker({
            map,
            icon,
            title: place.name,
            position: place.geometry.location,
          })
        );
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      map.fitBounds(bounds);
    });

    const options = {
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT,
        drawingModes: ["polygon"]
      },
      polygonOptions: {
        draggable: false,
        editable: false
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON
    };

    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);
    const that = this;
    google.maps.event.addListener(this.drawingManager, "polygoncomplete", function(polygon) {
      const len = polygon.getPath().getLength();
      const polyArrayLatLng = [];

      for (let i = 0; i < len; i++) {
        const vertex = polygon.getPath().getAt(i);
        const vertexLatLng = { latitude: vertex.lat(), longtitude: vertex.lng(),sequence: i+1 };
        polyArrayLatLng.push(vertexLatLng);
      }
      
      that.polyArrayLatLng = polyArrayLatLng;

      if(that.polygon){
        that.polygon.setMap(null);
      }
      that.polygon = polygon;
    });
  }

  focusOnLatLng(data: any){
    if(data != null){
      let locationArr = data.split(",");
      if(locationArr.length === 2){
        var latitude: number = +locationArr[0];
        var longitude: number = +locationArr[1];
        if(!isNaN(latitude) && !isNaN(longitude)){
          this.center = {
            lat: latitude,
            lng: longitude
          }
        }else{
          this.toaster.info("Please Enter Location in correct Format","Invalid")
        }
      }
    }else{
      this.toaster.info("Please Enter Location in correct Format","Invalid")
    }
  }

  private setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }
}